import { render, staticRenderFns } from "./configInstances.vue?vue&type=template&id=300a533a&scoped=true&"
import script from "./configInstances.vue?vue&type=script&lang=js&"
export * from "./configInstances.vue?vue&type=script&lang=js&"
import style0 from "./configInstances.vue?vue&type=style&index=0&id=300a533a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300a533a",
  null
  
)

export default component.exports